<quick-dashboard
  [loader]="loader"
  [uid]="'rag-tenants-dashboard'"
  [heading]="'Tenants'"
  [color]="'accent'"
  [columnOptions]="{
    '$$raw': { hidden: true },
    'id': { hidden: true },
    'name': { heading: 'Name', order: 1, renderTemplate: cellName },
    'description': { heading: 'Description', order: 2, hidden: true },
    'userCount': { heading: 'Users', order: 3 },
    'assistantCount': { heading: 'Assistants', order: 4 },
    'actions': {
      heading: 'Actions',
      order: 60,
      renderTemplate: cellActions,
      outerNgClass: 'cell-width-140'
     }
  }"
  [hasRouterOutlet]="true"
>
</quick-dashboard>

<ng-template #cellName let-rowItem=rowItem>
  <div class="fw-normal">
    {{rowItem['name']}}
    <div class="fw-light">{{rowItem['description']}}</div>
  </div>
</ng-template>

<ng-template #cellActions let-rowItem=rowItem>
  <div>
    <preview-button ngClass="ms-2" [routerLink]="['./preview', rowItem['id']]"></preview-button>
    <manage-button
      [useLinkButton]="true"
      [ngClass]="'ms-1'"
      [routerLink]="['./manage', rowItem['id']]"
    ></manage-button>
    <delete-button
      [useLinkButton]="true"
      [disabled]="rowItem['isSystem']"
      [ngClass]="'ms-1'"
      [routerLink]="rowItem['isSystem'] ? [] : ['./delete', rowItem['id']]"
    ></delete-button>
  </div>
</ng-template>
